module.exports = __webpack_public_path__ + "img/collection-engagementRingsHeart@2x.0a484a6.jpg";